import * as React from "react";
const SvgSortIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.2 6.932h15.6M4.2 12.127h10.92M4.2 17.07h5.98", fill: "none", stroke: "#000", strokeWidth: 1.5680196 }));
export default SvgSortIcon;
